module.exports = __webpack_public_path__ + "85c32b174b4f5e4a7f282351ae07ab8f.pdf";